<div class="modal-header">
  <h5 class="modal-title"> التسجيل</h5>

  <button type="button" class="close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">

    <div class="video vd">
      <div class="video-container">
        <!-- <iframe width="100%" height="300" [src]="transform(recordSource)" sandbox frameborder="0" allowfullscreen="allowfullscreen"></iframe> -->
        <video width="100%" height="332" controls>
          <source [src]="transform(recordSource)" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    <div class="col-lg-12 mt-4">
      <button type="button" class="btn-add btn-block" style="margin-bottom: 1rem;" (click)="close()">إغلاق</button>
    </div>
  </div>

</div>

<!-- <div  class="modal-body" style="margin:auto">
  <video width="320" height="240" controls>
    <source [src]="recordSource" type="video/mp4">
    <source [src]="recordSource" type="video/ogg">

    Your browser does not support the video tag.
  </video>
</div> -->
